<template>
  <div>ExpansionPanel</div>
</template>
<script setup></script>
